module.exports = __webpack_public_path__ + "static/media/snake.e21f2e77.svg";